import React from "react";
import SuperAdminDashLayout from "../masterLayout/SuperAdminDashLayout";
import EnquiryFormPageLayer from "../components/EnquiryFormPageLayer";

const EnquiryFormPage = () => {
  return (
    <>
      <SuperAdminDashLayout>
        <EnquiryFormPageLayer />
      </SuperAdminDashLayout>
    </>
  );
};

export default EnquiryFormPage;
